import useTranslation from "next-translate/useTranslation";
import React, { VFC } from "react";
import styled from "styled-components";
import Image from "~/components/atoms/Image";
import InputSearch from "~/components/modules/search/inputSearch";
import { convertUrlObjectToString } from "~/lib/utils/urlHelper";
import { staticPath, pagesPath } from "faqSrc/lib/$path";

const HeaderSearch: VFC = () => {
  const { t } = useTranslation();
  return (
    <>
      <SearchIconWrap
        {...{
          on: "tap:headerInner.toggleClass(class='has-search'),headerSearchIcon.hide,headerSearchForm.show",
        }}
        aria-label="search"
        role="button"
        tabIndex={0}
        id="headerSearchIcon"
      >
        <Image
          src={staticPath.img.icon_search_svg}
          width="24"
          height="24"
          alt="search"
        />
      </SearchIconWrap>
      <div id="headerSearchForm" hidden>
        <form
          method="get"
          action={convertUrlObjectToString({ url: pagesPath.qa.search.$url() })}
          target="_top"
          id="searchForm"
        >
          <InputSearch
            inputProps={{
              name: "q",
              placeholder: t("common:header.search-placeholder"),
            }}
            iconSearchProps={{
              ...{ on: "tap:searchForm.submit" },
              role: "button",
              tabIndex: 0,
            }}
            isSmall
          />
        </form>
      </div>
    </>
  );
};

const SearchIconWrap = styled.div`
  cursor: pointer;
  height: 24px;
`;

export default HeaderSearch;
